// @flow
/* eslint pinterest/no-translation-outside-of-function:0 */
/* eslint prefer-numeric-literals:0 */
/* eslint no-bitwise:0 */

import BrowserType from 'app/packages/browser';
/*
 * Note: some consts from this file have been moved to webapp/const/js.json
 * The consts in js.json are inlined into our source files and referenced
 * using PCONST.
 *
 * This gives us savings as we don't include the full list of constants in
 * every bundle, and saves bundle size since a lot of the values are much shorter
 * than the keys.
 */

const CONST = {};

/**
 * Step types for user education guide
 *
 * @enum {string}
 */
const ViewActions = {
  OPEN: 'open',
  CLOSE: 'close',
};

/**
 * @enum {string}
 */
const BoardPrivacy = {
  SECRET: 'secret',
  PUBLIC: 'public',
  PROTECTED: 'protected',
};
// TODO(mwalker) this is already defined in packages/pinterest-flow-types
// perhaps we should only keep values here and leave the types in packages
export type BoardPrivacyType = 'secret' | 'public' | 'protected';

/**
 * @enum {string}
 */
const BoardType = {
  PROTECTED: 'protected',
};

/**
 * @enum {string}
 */
const BulkAction = {
  MOVE: 'bulkMove',
  COPY: 'bulkCopy',
  DELETE: 'bulkDelete',
};
export type BulkActionType = $Values<typeof BulkAction>;

/**
 * From https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.core.js
 * @const
 * @type {Object.<string, number>}
 */
const KeyCode = {
  BACKSPACE: 8,
  COMMA: 188,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  NUMPAD_ADD: 107,
  NUMPAD_DECIMAL: 110,
  NUMPAD_DIVIDE: 111,
  NUMPAD_ENTER: 108,
  NUMPAD_MULTIPLY: 106,
  NUMPAD_SUBTRACT: 109,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38,
};

/**
 * This file stores the constants that we use across all our javascript files
 */

CONST.MAX_STORED_VISITED_PAGES = 100;
CONST.MAX_STORED_VISITED_PIN_PAGES = 10;

// response codes
CONST.RESPONSE_CODE_TOO_MANY_REQUESTS = 429;

// form max validators
CONST.MAX_CHARS_FOR_BOARD_TITLE = 50;
CONST.MAX_CHARS_FOR_USER_DESCRIPTION = 160;
CONST.MAX_CHARS_FOR_BOARD_PIN_DESCRIPTION = 500;
CONST.MAX_CHARS_FOR_PIN_TITLE = 100;
CONST.MAX_CHARS_FOR_PIN_DESCRIPTION = 500;
CONST.MAX_CHARS_FOR_FIRST_NAME = 30;
CONST.MAX_CHARS_FOR_LAST_NAME = 30;

// Max number of followers to return per 'page'
CONST.MAX_FETCH_NUM_FOLLOWERS_PER_PAGE = 50;

CONST.BoardPrivacy = BoardPrivacy;
CONST.BoardType = BoardType;
CONST.BrowserType = BrowserType;
CONST.BulkAction = BulkAction;
CONST.KeyCode = KeyCode;
CONST.ViewActions = ViewActions;

CONST.SCROLL_THROTTLE_DELAY_DEFAULT = 14;

// API errors
CONST.API_SERVER_ERROR = 12;
CONST.API_SERVER_SPAM_CONTENT = 14;
CONST.API_REQUEST_TIMEOUT = 16;
CONST.API_ERROR_PIN_NOT_FOUND = 50;
CONST.INVALID_PASSWORD_GOOGLE_USER = 76;
CONST.INVALID_PASSWORD_FB_USER = 77;
CONST.INVALID_PASSWORD_ERROR_CODE = 78;
CONST.INVALID_EMAIL_ERROR_CODE = 79;
CONST.POLICY_VIOLATION_USER = 83;
CONST.AUTO_PASSWORD_RESET_ERROR_CODE = 85;
CONST.API_ERROR_UNDERAGE_REGISTER_ATTEMPT = 93;

CONST.API_LIMIT_EXCEEDED_ERROR = 8;
CONST.API_EVENT_BLOCKED_ERROR = 9;
CONST.USER_IN_SAFE_MODE = 19;
CONST.LOGIN_VOLUNTARILY_DEACTIVATED_USER = 84;
CONST.LOGIN_BAD_PASSWORD_ASK_RESET = 85;
CONST.LOGIN_MFA_REQUIRED = 1201;
CONST.LOGIN_USER_NOT_FOUND = 30;
CONST.LOGIN_HARD_BANNED_USER = 88;
CONST.FACEBOOK_ACCOUNT_NOT_LINKED = 105;
CONST.SIGNUP_INVALID_EMAIL = 95;

/**
 * The Guided Search feature is currently English-only.
 *
 * TODO(yuliang): Support i18n for this feature.
 * TODO(chris): For this list of words, either fetch it from the API, or share it via
 * Thrift constants so that we won't get out of sync with mobile clients.
 */
CONST.SEARCH_FILTER_CONJUNCTIONS = [
  'and',
  'that',
  'but',
  'or',
  'as',
  'if',
  'when',
  'than',
  'because',
  'while',
  'where',
  'after',
  'so',
  'though',
  'since',
  'until',
  'whether',
  'before',
  'although',
  'nor',
  'like',
  'once',
  'unless',
  'now',
  'except',
  'the',
  'a',
  'an',
  'san',
  'for',
  'in',
  'with',
];

CONST.DEFAULT_IMAGELESS_PIN_COLOR = '#8fa7bf';

CONST.SHOWCASE_TYPE_ARTICLE = 'explorearticle';
CONST.SHOWCASE_TYPE_BOARD = 'board';
CONST.SHOWCASE_TYPE_SHOP = 'shop_recommendation_collection';

CONST.VIDEO_IFRAME_ID = 'video-iframe';

CONST.AMP_TRACKING_DOMAIN = 'amp.pinterest.com';

CONST.PHONE_NUMBER_SIGNUP_EMAIL_SUBDOMAIN = '@phone.pinterest.com';

// Constants for web account switcher
CONST.MULTIPLE_ACCOUNTS = 'MULTIPLE_ACCOUNTS';
CONST.MULTIPLE_ACCOUNTS_GROUP = 'MULTIPLE_ACCOUNTS_GROUP';

export default CONST;
